import Punchline from './Punchline';

export * from './Punchline';

export default Punchline;
